import { translationEs } from 'utils/i18next/es';
import { translationEn } from 'utils/i18next/en';

export const buildI18nOptions = (lng) => ({
  resources: {
    es: { translation: translationEs },
    en: { translation: translationEn },
  },
  ...(!!lng && { lng }),
  supportedLngs: ['es', 'en'],
  nonExplicitSupportedLngs: true,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});
